/**
 * usePrint - Shared composable for paper size management.
 *
 * PDF generation is handled server-side:
 * - Billing invoices: GET /v1/invoices/{id}/pdf?paper_size=A5
 * - Future: POS receipts, Seva donations will use similar server endpoints
 *
 * This composable only manages paper size settings (localStorage + billing settings API).
 */
import { ref } from 'vue'

/** Standard paper size definitions (mm) */
const PAPER_SIZES = {
  'A4': { width: 210, height: 297, name: 'a4' },
  'A5': { width: 148, height: 210, name: 'a5' },
  '80mm': { width: 80, height: 200, name: [80, 200] },
  '58mm': { width: 58, height: 150, name: [58, 150] },
}

/**
 * @param {Object} options
 * @param {string} options.storageKey - localStorage key for paper size (default: 'pos_paper_size')
 * @param {string} options.defaultSize - Default paper size: 'A4' | 'A5' | '80mm' | '58mm' (default: 'A4')
 */
export function usePrint({ storageKey = 'pos_paper_size', defaultSize = 'A4' } = {}) {
  const paperSize = ref(localStorage.getItem(storageKey) || defaultSize)

  /** Persist paper size to localStorage */
  const savePaperSize = (size) => {
    paperSize.value = size
    localStorage.setItem(storageKey, size)
  }

  /** Print using browser print dialog */
  const printDirect = () => {
    window.print()
  }

  return {
    paperSize,
    PAPER_SIZES,
    savePaperSize,
    printDirect,
  }
}
